module.exports = __webpack_public_path__ + "img/fallbackprovider.94c5149f.png";